import { i18nMark } from 'lingui-react';

const formattedMessages = {
  asset: i18nMark('Asset'),
};

export default formattedMessages;



// WEBPACK FOOTER //
// ./components/WizardSteps/AssetSelection/messages.js